import React from 'react';

import { IPressBarFields } from '../../../types/contentful';

import { BlockContainer, Column, Layout } from '../Layout';

import { PressBarContainer, PressItem, PressText, StyledImage } from './styles';
import { getImageData } from 'src/utils/contentful';
import { Box } from '../Box';
import { useMediaQuery } from 'src/hooks/useMediaQuery';
import { toSentenceCase } from '~/utils/stringUtils';

export function PressBar({ pressHeader, pressLogos }: IPressBarFields) {
  const isDesktop = useMediaQuery('desktop');
  const isTablet = useMediaQuery('tablet');
  const desktopLayout = isDesktop || isTablet;
  return (
    <PressBarContainer
      data-blockid="socialProofContainer"
      data-testid="socialProofContainer"
    >
      <BlockContainer
        marginTop={{ 0: 0, tablet: 'm' }}
        marginBottom={{ 0: 0, tablet: 'm' }}
        data-blockid="asFeaturedOn"
      >
        <Layout
          data-blockid="asFeaturedOnLayout"
          gutter="sm"
          flexDirection={'column'}
        >
          {pressHeader && (
            <Box marginBottom={{ 0: 'sm' }}>
              <PressText
                as="h1"
                fontWeight={{ 0: '600' }}
                fontSize={{ 0: 'sm', desktop: 'sm' }}
                data-blockid="pressBar-headline"
                data-testid="pressBar-headline"
                textAlign={'center'}
              >
                {toSentenceCase(pressHeader)}
              </PressText>
            </Box>
          )}
          <Layout>
            {desktopLayout && (
              <Column
                size={{ 0: 12 }}
                justifyContent="space-evenly"
                alignItems="center"
              >
                {pressLogos?.map((pressLogo) => (
                  <PressItem
                    key={pressLogo.fields.description}
                    margin={['s', 0]}
                    padding={[0, 'xs']}
                  >
                    <StyledImage
                      {...getImageData(pressLogo)}
                      data-blockid="pressBar-image"
                      layout="fill"
                      width={undefined}
                      height={undefined}
                    />
                  </PressItem>
                ))}
              </Column>
            )}
            {!desktopLayout &&
              pressLogos?.map((pressLogo) => (
                <Column
                  key={pressLogo.fields.description}
                  size={{ 0: 6 }}
                  justifyContent="space-evenly"
                  alignItems="center"
                >
                  <PressItem
                    key={pressLogo.fields.description}
                    margin={['s', 0]}
                    padding={[0, 'xs']}
                  >
                    <StyledImage
                      {...getImageData(pressLogo)}
                      data-blockid="pressBar-image"
                      layout="fill"
                      width={undefined}
                      height={undefined}
                    />
                  </PressItem>
                </Column>
              ))}
          </Layout>
        </Layout>
      </BlockContainer>
    </PressBarContainer>
  );
}
